import styled from 'styled-components'
import {
  theme,
  px2rem,
  StyledH5,
  StyledParagraph
} from '../../../../../theme/Global'

export const CustomH5 = styled(StyledH5)`
  text-align: left;
`

export const Subheading = styled(StyledH5)`
  margin: 0.6rem 0;
  padding: 0;
  text-align: left;
`

export const MarkdownWrap = styled(StyledParagraph)`
  margin-left: ${px2rem(27)}rem;
`

export const LawCitation = styled.cite`
  margin: ${px2rem(17)}rem 0 ${px2rem(25)}rem 0;
  text-align: right;
  width: 100%;
  display: block;
  color: ${theme.colors.text};
  font-size: ${px2rem(15)}rem;
  font-style: inherit;
  font-weight: 600;
`

export const DetailsHeading = styled.h3`
  font-weight: 600;
  text-align: left;
  color: ${theme.colors.redText};
  padding: ${px2rem(16)}rem 0;
  margin: 0 auto;
  font-size: ${px2rem(24)}rem;
  font-weight: 600;
  text-align: center;
`

export const DetailsHardRule = styled.hr`
  width: 95%;
  border: 1px solid ${theme.colors.divider};
`

export const DetailsContentHeading = styled.h2`
  font-size: ${px2rem(18)}rem;
  font-weight: 600;
  color: ${theme.colors.darkBlueText};
`
export const DetailsSummaryHeading = styled(DetailsContentHeading)``
export const DetailsTopicHeading = styled(DetailsContentHeading)`
  margin-top: ${px2rem(23.5)}rem;
  margin-bottom: ${px2rem(24)}rem;
`

export const DetailsSubTopicHeading = styled.h5`
  text-transform: capitalize;
  font-size: ${px2rem(15)}rem;
  font-weight: 600;
`

export const DetailsSummaryContent = styled.div`
  margin-left: ${px2rem(25)}rem;
  font-size: ${px2rem(15)}rem;
  color: ${theme.colors.text};
  && p {
    margin-top: 0;
  }
`

export const TopicsDetailContainer = styled.div`
  margin: 0;
  ${DetailsHeading} {
  margin-top: 2.2rem;
  }
`
